import { Box } from "@mui/material";
import { AppImages } from "app/appImages";
import { AssessmentInstanceDto, AssessmentType } from "generated/CoreApi_v1";
import React from "react";

/////////////////////////////////////////////////////////////////////////////////

interface IProps {
    viewData: AssessmentInstanceDto;
}

export const AssPlayerImage: React.FC<IProps> = ({ viewData }) => {
    return (
        <Box
            component="img"
            minHeight="180px"
            maxHeight="180px"
            src={viewData.thumbnailUrl != null
                ? viewData.thumbnailUrl
                : viewData.assessmentType == AssessmentType.Evaluation
                    ? AppImages.LmsContentTypeEvaluationThumbnail
                    : AppImages.LmsContentTypeSurveyThumbnail}
        />
    );
};
